function injectElementOnMobile() {
  const jciMobileGallaryContainer = document.querySelector('.product-form.off-card-container.sticky-content-container');
  const jciGallery = document.querySelector('.product_image_block_section')
  const jciBage = document.querySelectorAll('.product-label-container')
  const jciBageChild = document.querySelectorAll('.product-label-container .jci-custom-bage')

  window.jciBage = jciBage;

  
  
  if (window.innerWidth <= 767 ) {
    // console.log({jciGallery})
    const fifthChild = jciMobileGallaryContainer.children[4];
    jciMobileGallaryContainer.insertBefore(jciGallery, fifthChild);
    // jciMobileGallaryContainer.innerHTML = jciGallery.innerHTML;
    //  jciGallery.remove();
    // jciBage.remove();
    if (jciBageChild.length > 1) {
      [...jciBageChild].forEach((el, idx, arr) => {
        if (idx !== arr.length - 2 && idx !== 1) el.remove(); // keep only the second-last
      });
    }
  }
}

function toggleDescription() {
  const description = document.querySelector('.product-info-block .jci-product-description');
  const seeMoreBtn = document.getElementById('seeMoreBtn');
  
  if (description.classList.contains('full-description')) {
    description.classList.remove('full-description');
    seeMoreBtn.textContent = 'See More';
  } else {
    description.classList.add('full-description');
    seeMoreBtn.textContent = 'See Less';
  }
}



window.addEventListener('DOMContentLoaded', injectElementOnMobile);
window.addEventListener('DOMContentLoaded', () => {
  const bageOfProductPage = document.querySelectorAll('.template-product .product-label-container');
  
  if (bageOfProductPage?.length > 0 ) {
    bageOfProductPage[bageOfProductPage?.length-1].remove()
  }
  // Delay a bit so MagicZoom can initialize first
  setTimeout(() => {
    const THUMB_SELECTOR = '.MagicToolboxSelectorsContainer .mz-thumb';
    const BADGE_SELECTOR = '.product-label-container .jci-custom-bage';
    // Update these if your arrows use different classes
    const NAV_SELECTOR = [
      '.mz-button.mz-button-next',
      '.mz-button.mz-button-prev',
      '.mz-next',
      '.mz-prev'
    ].join(', ');
    
    function updateBadges() {
      const thumbs = document.querySelectorAll(THUMB_SELECTOR);
      if (!thumbs.length) return;
      
      let idx = [...thumbs].findIndex(t => t.classList.contains('mz-thumb-selected'));
      if (idx < 0) idx = 0;
      
      const badges = document.querySelectorAll(BADGE_SELECTOR);
      badges.forEach((b, i) => {
        // Hide extra badges if the selected thumb is the 3rd or later
        b.style.display = (idx > 0 && i > 0) ? 'none' : '';
      });
    }
    
    // Click on thumbs OR next/prev arrows
    document.addEventListener('click', (e) => {
      if (e.target.closest(THUMB_SELECTOR) || e.target.closest(NAV_SELECTOR)) {
        // Defer until MagicZoom updates classes
        setTimeout(updateBadges, 0);
      }
    });
    
    // Optional: keyboard nav (left/right arrows)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        setTimeout(updateBadges, 0);
      }
    });

    // Fallback: observe class changes on thumbs (covers swipes/autoplay)
    const selectorsContainer = document.querySelector('.MagicToolboxSelectorsContainer');
    if (selectorsContainer && 'MutationObserver' in window) {
      const mo = new MutationObserver((mutations) => {
        if (mutations.some(m => m.type === 'attributes' && m.attributeName === 'class')) {
          updateBadges();
        }
      });
      mo.observe(selectorsContainer, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    // Initial run
    updateBadges();

    // Keep your original opacity tweak
    document.querySelectorAll('.jci-custom-bage').forEach(el => {
      el.style.opacity = '1';
    });
  }, 1000);
});


window.addEventListener('resize', () => {
 
   injectElementOnMobile()

   
   if (window.innerWidth > 767) {
       const jciDesktopContainer = document.querySelector('.product-detail.quickbuy-content');
       const jciGallery = document.querySelector('.product_image_block_section')

    // Check if both elements exist
    if (jciDesktopContainer && jciGallery) {
      jciDesktopContainer.insertBefore(jciGallery, jciDesktopContainer.firstChild); // Insert as the first child
    }
  }

} );

